"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { jsx } from 'react/jsx-runtime';
import { withSlotScopeClasses } from '../../../helpers/scoped-slots.mjs';
import { forwardRef } from 'react';
import { tv } from 'tailwind-variants';

const comboboxContainerRecipe = tv({
  slots: withSlotScopeClasses("combobox-container", {
    root: [
      "inline-flex align-middle w-fit max-w-full h-full grow cursor-pointer px-1",
      "[&:hover:not(:has([data-editor-tag='true']:hover))_p]:bg-bg-subtle",
      "[&[aria-expanded='true']_p]:bg-bg-subtle"
    ]
  }),
  variants: {
    disabled: {
      true: { root: "bg-bg-subtle cursor-[initial]" }
    },
    level: {
      editor: {},
      tag: { root: "py-0 mx-[3px] [[contenteditable='true']_&]:my-[3px]" }
    }
  }
});
const ComboboxContainer = forwardRef(({ children, disabled, className, level, ...props }, ref) => {
  const styles = comboboxContainerRecipe({ disabled, level });
  return /* @__PURE__ */ jsx(
    "div",
    {
      role: "combobox",
      className: styles.root({ className }),
      ref,
      "aria-disabled": disabled,
      "aria-readonly": disabled,
      ...props,
      children
    }
  );
});

export { ComboboxContainer };
